import { FC, useState } from "react";
import { A11y, Autoplay, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import { Img } from "@/components/atoms/img/Img";
import EditorFrame from "@/components/editors/EditorFrame";
import { SliderTypeTemplate as ISlider } from "@/states/page-editor/template-parts/slider";
import { isEmptyValue } from "@/utils/common";
import { defaultSliderSimpleImgSrc } from "@/utils/convert-page-json";

import ChevronLeftIcon from "/public/img/edit/template-blocks/slider-chevron-left.svg";

interface SliderTemplateProps {
  part: ISlider;
}

export const SliderTemplate: FC<SliderTemplateProps> = ({ part }) => {
  const slider = part;
  const [prevEl, setPrevEl] = useState<HTMLElement | null>(null);
  const [nextEl, setNextEl] = useState<HTMLElement | null>(null);

  /* 画像未設定の場合、デフォルト画像を表示 */
  const imgSrc = (url: string | undefined) => {
    return !url || isEmptyValue(url) ? defaultSliderSimpleImgSrc : url;
  };

  /**
   * 指定のURLに遷移する
   */
  const handleClickLink = (url: string, isNewTab = false) => {
    if (isNewTab) {
      window.open(url, "_blank");
      return;
    }
    window.location.href = url;
  };
  return (
    <>
      {!part.deleted && (
        <EditorFrame isNoPadding>
          <div className="mt-10">
            <Swiper
              modules={[Navigation, A11y, Autoplay]}
              slidesPerView={1}
              spaceBetween={24}
              loop={true}
              breakpoints={{
                768: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                },
              }}
              navigation={{ prevEl, nextEl }}
              className="flex items-start w-full h-min"
              autoplay={
                slider.autoPlay
                  ? {
                      delay: 3000,
                      disableOnInteraction: false,
                    }
                  : undefined
              }
            >
              {slider.slides.map((item, idx) => (
                <SwiperSlide
                  key={idx}
                  className="self-center h-min md:px-0 image-container"
                  onClick={() => {
                    if (item.href) {
                      handleClickLink(item.href, item.targetBlank);
                    }
                  }}
                >
                  <Img
                    src={imgSrc(item.image)}
                    className="w-full cursor-pointer"
                  />
                </SwiperSlide>
              ))}
              <button
                type="button"
                ref={(node) => setPrevEl(node)}
                className="absolute top-1/2 left-0 z-[2] -translate-y-1/2 md:left-[6%] md:-translate-x-[25px]"
              >
                <ChevronLeftIcon className="w-8 h-8 fill-white" title="前へ" />
              </button>
              <button
                type="button"
                ref={(node) => setNextEl(node)}
                className="absolute top-1/2 right-0 z-[2] -translate-y-1/2 md:right-[6%] md:translate-x-[25px]"
              >
                <ChevronLeftIcon
                  className="w-8 h-8 -scale-x-90 fill-white"
                  title="次へ"
                />
              </button>
            </Swiper>
          </div>
        </EditorFrame>
      )}
    </>
  );
};
